var map = {
	"./nav011.png": "D0K2",
	"./nav1.png": "32fb",
	"./nav2.png": "YOe0",
	"./nav3.png": "fVgY",
	"./nav4.png": "935W"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cu+p";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/index ^\.\/nav.*\.png$
// module id = cu+p
// module chunks = 1